import { HeaderItemWrapper } from './styles';
import { FC, useMemo } from 'react';
import { useTranslation } from 'next-i18next';

const TableHeaderColumn: FC = () => {
  const { t } = useTranslation(['users', 'common']);

  const FIELDS = useMemo(
    () => [
      { identifier: 'NICKNAME', title: t('nickname') },
      { identifier: 'FULL_NAME', title: t('full_name') },
      { identifier: 'EMAIL', title: t('email') },
      { identifier: 'ROLE', title: t('role') },
      { identifier: 'IDENTIFIER', title: t('identifier') },
      { identifier: 'CREATED_AT', title: t('joined') },
      { identifier: 'LAST_ACTIVITY', title: t('last_login') },
    ],
    [t]
  );

  return (
    <>
      {FIELDS.map(column => (
        <HeaderItemWrapper key={column.identifier}>{column.title}</HeaderItemWrapper>
      ))}
    </>
  );
};

export default TableHeaderColumn;
